import HttpClienteToken from '../../services/HttpClientToken';

import { MateriaProps } from '../../interfaces/catalogos/MateriaInterface';

export const Materia = () => {

    return new Promise<MateriaProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Materia/', token)
            .then( ({ data } : { data : MateriaProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerMateria = () => {

    return new Promise<MateriaProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Materia/ObtenerMateria', token)
            .then( ({ data } : { data : MateriaProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarMateria = ( params: MateriaProps ) => {

    return new Promise<MateriaProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Materia/Actualizar', params, token)
            .then( ({ data } : { data : MateriaProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idMateria: 0,                 
                    descripcion: '',
                    activo: false,     
                });
            });
        }

    });

}

export const AgregarMateria = ( params: MateriaProps ) => {

    return new Promise<MateriaProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Materia/Agregar', params, token)
            .then( ({ data } : { data : MateriaProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idMateria: 0,                   
                    descripcion: '',
                    activo: false,    
                });
            });
        }

    });

}